// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rw-c";
export var backButton = "_rw-4";
export var backIcon = "_rw-5";
export var chevronShortcut = "_rw-6";
export var container = "_rw-1";
export var editor = "_rw-8";
export var editorWrapper = "_rw-7";
export var prefix = "_rw-2";
export var searchIcon = "_rw-3";
export var suffix = "_rw-9";
export var suffixContent = "_rw-a";
export var suffixText = "_rw-b";
export var wrapper = "_rw-0";